export default "__VITE_ASSET__BuD2D9xu__"